import React from "react";
import {
  GatewayMachine,
  GatewayWithMachinesViewStateTypes,
} from "@src/types/gateways-with-machines";
import { GatewayMachineListRow } from "@src/components/molecules/gateway-machine-list-row/gateway-machine-list-row";

export interface GatewayMachinesListProps {
  gatewayData: GatewayWithMachinesViewStateTypes;
}

export const GatewayMachinesList = ({
  gatewayData,
}: GatewayMachinesListProps) => {
  return (
    <tbody>
      {gatewayData.machines.map((machine: GatewayMachine) => {
        const rowIdentity = machine.machine_id;

        return (
          <GatewayMachineListRow
            key={rowIdentity}
            gatewayData={gatewayData}
            machine={machine}
          />
        );
      })}
    </tbody>
  );
};
